var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.user
    ? _c("div", { staticClass: "p-3" }, [
        _c("h2", { staticClass: "text-center" }, [
          _vm._v("SELAMAT DATANG DI PORTAL PENDAFTARAN"),
        ]),
        _vm._v(" "),
        _c("h4", { staticClass: "text-center" }, [
          _vm._v(
            "Anda Sedang Berada Di Halaman Konfigurasi Pendaftaran Online"
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "d-grid gap2 col-4 mt-5 mx-auto" },
            [
              _c(
                "b-card-group",
                { attrs: { deck: "" } },
                [
                  _c(
                    "b-card",
                    {
                      attrs: {
                        header: "KONFIGURASI METODE PENDAFTARAN",
                        "header-bg-variant": "success",
                        "header-text-variant": "white",
                        align: "center",
                      },
                    },
                    [
                      _c("b-card-text", [
                        _vm._v(
                          "\n                        Konfigurasi Metode Pendaftaran dan Loket Pendaftaran.\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-link",
                        {
                          staticClass: "btn btn-success mt-3",
                          attrs: {
                            to: "/konfigurasi-loket-pendaftaran-online",
                          },
                        },
                        [
                          _vm._v("Lihat Lebih Lengkap "),
                          _c("b-icon", { attrs: { icon: "arrow-right" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-grid gap2 col-4 mt-5 mx-auto" },
            [
              _c(
                "b-card-group",
                { attrs: { deck: "" } },
                [
                  _c(
                    "b-card",
                    {
                      attrs: {
                        header: "WEBSITE",
                        "header-bg-variant": "success",
                        "header-text-variant": "white",
                        align: "center",
                      },
                    },
                    [
                      _c("b-card-text", [
                        _vm._v(
                          "\n                        Konfigurasi Halaman Portal Website Pendaftaran Online\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-link",
                        {
                          staticClass: "btn btn-success mt-3",
                          attrs: { to: "/konfigurasi-website" },
                        },
                        [
                          _vm._v("Lihat Lebih Lengkap "),
                          _c("b-icon", { attrs: { icon: "arrow-right" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-grid gap2 col-4 mt-5 mx-auto" },
            [
              _c(
                "b-card-group",
                { attrs: { deck: "" } },
                [
                  _c(
                    "b-card",
                    {
                      attrs: {
                        header: "KONFIGURASI USER",
                        "header-bg-variant": "success",
                        "header-text-variant": "white",
                        align: "center",
                      },
                    },
                    [
                      _c("b-card-text", [
                        _vm._v(
                          "\n                        Konfigurasi User Website Pendaftaran Online\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-link",
                        {
                          staticClass: "btn btn-success mt-3",
                          attrs: { to: "/konfigurasi-user" },
                        },
                        [
                          _vm._v("Lihat Lebih Lengkap "),
                          _c("b-icon", { attrs: { icon: "arrow-right" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-grid gap2 col-4 mt-5 mx-auto" },
            [
              _c(
                "b-card-group",
                { attrs: { deck: "" } },
                [
                  _c(
                    "b-card",
                    {
                      attrs: {
                        header: "KONFIGURASI KUOTA POLI",
                        "header-bg-variant": "success",
                        "header-text-variant": "white",
                        align: "center",
                      },
                    },
                    [
                      _c("b-card-text", [
                        _vm._v(
                          "\n                        Konfigurasi Kuota Pendaftaran Per Poli\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-link",
                        {
                          staticClass: "btn btn-success mt-3",
                          attrs: { to: "/konfigurasi-kuota-poli" },
                        },
                        [
                          _vm._v("Lihat Lebih Lengkap "),
                          _c("b-icon", { attrs: { icon: "arrow-right" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-grid gap2 col-4 mt-5 mx-auto" },
            [
              _c(
                "b-card-group",
                { attrs: { deck: "" } },
                [
                  _c(
                    "b-card",
                    {
                      attrs: {
                        header: "KONFIGURASI KATEGORI",
                        "header-bg-variant": "success",
                        "header-text-variant": "white",
                        align: "center",
                      },
                    },
                    [
                      _c("b-card-text", [
                        _vm._v(
                          "\n                        Konfigurasi Kategori Antrean.\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-link",
                        {
                          staticClass: "btn btn-success mt-3",
                          attrs: { to: "/konfigurasi-kategori-antrean" },
                        },
                        [
                          _vm._v("Lihat Lebih Lengkap "),
                          _c("b-icon", { attrs: { icon: "arrow-right" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-grid gap2 col-4 mt-5 mx-auto" },
            [
              _c(
                "b-card-group",
                { attrs: { deck: "" } },
                [
                  _c(
                    "b-card",
                    {
                      attrs: {
                        header: "KONFIGURASI MASTER LOKET",
                        "header-bg-variant": "success",
                        "header-text-variant": "white",
                        align: "center",
                      },
                    },
                    [
                      _c("b-card-text", [
                        _vm._v(
                          "\n                        Konfigurasi Master Loket.\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-link",
                        {
                          staticClass: "btn btn-success mt-3",
                          attrs: { to: "/konfigurasi-master-loket" },
                        },
                        [
                          _vm._v("Lihat Lebih Lengkap "),
                          _c("b-icon", { attrs: { icon: "arrow-right" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-grid gap2 col-4 mt-5 mx-auto" },
            [
              _c(
                "b-card-group",
                { attrs: { deck: "" } },
                [
                  _c(
                    "b-card",
                    {
                      attrs: {
                        header: "KONFIGURASI MASTER LOKET PENDAFTARAN",
                        "header-bg-variant": "success",
                        "header-text-variant": "white",
                        align: "center",
                      },
                    },
                    [
                      _c("b-card-text", [
                        _vm._v(
                          "\n                        Konfigurasi Master Loket Pendaftaran.\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-link",
                        {
                          staticClass: "btn btn-success mt-3",
                          attrs: { to: "/konfigurasi-loket-pendaftaran" },
                        },
                        [
                          _vm._v("Lihat Lebih Lengkap "),
                          _c("b-icon", { attrs: { icon: "arrow-right" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "d-grid gap2 col-4 mt-5 mx-auto" },
            [
              _c(
                "b-card-group",
                { attrs: { deck: "" } },
                [
                  _c(
                    "b-card",
                    {
                      attrs: {
                        header: "PENGUMUMAN",
                        "header-bg-variant": "success",
                        "header-text-variant": "white",
                        align: "center",
                      },
                    },
                    [
                      _c("b-card-text", [
                        _vm._v(
                          "\n                        Pengaturan Pengumuman.\n                    "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-link",
                        {
                          staticClass: "btn btn-success mt-3",
                          attrs: { to: "/konfigurasi-pengumuman" },
                        },
                        [
                          _vm._v("Lihat Lebih Lengkap "),
                          _c("b-icon", { attrs: { icon: "arrow-right" } }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }